<template>
  <!-- :transfer-class-name="filterable && data.length > 0 ? 'transfer-select' : ''" -->
  <Select ref="select" :label-in-value="labelInValue" @on-open-change="_changeOpen" class="yselect" transfer :multiple="multiple" :filterable="filterable" :model-value="modelValue" :clearable="clearable" v-bind="$attrs" :style="{ width: width }" @on-change="_change" @on-clear="_clear">
    <template #prefix>
      <slot name="prefix"></slot>
    </template>
    <slot name="extraContent"></slot>
    <Option v-for="item in data" :label="value == '' ? item : item[label]" :value="value == '' ? item : item[value]" :key="value == '' ? item : item[value]"> </Option>
  </Select>
</template>

<script setup>
import { ref } from 'vue'
const emit = defineEmits(['update:modelValue', 'on-change'])
const props = defineProps({
  data: {
    type: Array,
    default: []
  },
  multiple: {
    type: Boolean,
    default: false
  },
  width: {
    type: String,
    default: '206px'
  },
  label: {
    type: String,
    default: 'label'
  },
  value: {
    type: String,
    default: 'value'
  },
  clearable: {
    type: Boolean,
    default: true
  },
  filterable: {
    type: Boolean,
    default: true
  },
  labelInValue: {
    type: Boolean,
    default: false
  },
  modelValue: {}
})
const select = ref(null)
function _changeOpen(val) {
  if (val) {
    select.value.query = ''
  }
}
function _change(val) {
  let ret = val === undefined ? '' : val
  emit('update:modelValue', ret)
  emit('on-change', ret)
}
function _clear() {
  emit('update:modelValue', '')
  // emit('on-change', '')
}
</script>
<style lang="less" scoped>
.select-input {
  z-index: 3000;
  margin: 4px;
  display: block;
}
</style>
<!-- <style>
.transfer-select {
  padding-top: 35px;
}
</style> -->
